import requset from "utils/request";
import { AUTHOR, WRITE } from "apiurl/index.js";
export function applyWriter(params) {
  return requset({
    url: `${AUTHOR}/author/register`,
    method: "POST",
    params
  });
}
/* 作品列表 */
export function AuthorBookList(params) {
  return requset({
    url: `${WRITE}/book/author/list`,
    method: "GET",
    params
  });
}
// 获取完本状态
export function getfinishbook(id) {
  return requset({
    url: `${WRITE}/book/finish/status/${id}`,
    method: "GET"
  });
}
// 设置完本
export function finishbook(id) {
  return requset({
    url: `${WRITE}/book/finish/${id}`,
    method: "GET"
  });
}
/* 删除作品 */
export function delectbook(id) {
  return requset({
    url: `${WRITE}/book/del/${id}`,
    method: "GET"
  });
}
/* 签约作品管理 */
export function signBookList(params) {
  return requset({
    url: `${WRITE}/sign/book/list`,
    method: "GET",
    params
  });
}
/* 分类列表===创建作品 */
export function sortList() {
  return requset({
    url: `${WRITE}/book/sort/type`,
    method: "GET"
  });
}
/* 添加作品 */
export function addbook(params) {
  return requset({
    url: `${WRITE}/book/add`,
    method: "POST",
    params
  });
}
/* 获取tags列表 */
export function tagslist() {
  return requset({
    url: `${WRITE}/book/tag/list`,
    method: "GET"
  });
}
/* 修改作品信息 */
export function editbook(params, bookid) {
  return requset({
    url: `${WRITE}/book/edit/${bookid}`,
    method: "POST",
    params
  });
}
/* 根据作品id获取可编辑信息 */
export function getbookinfo(bookid) {
  return requset({
    url: `${WRITE}/book/edit/${bookid}`,
    method: "get"
  });
}
/* 获取作品的卷信息 */
export function getvolume(bookid) {
  return requset({
    url: `${WRITE}/volume/${bookid}`,
    method: "get"
  });
}
/* 新建分卷 */
export function addVolume(params) {
  return requset({
    url: `${WRITE}/volume/add`,
    method: "POST",
    params
  });
}
/* 编辑分卷 */
export function editVolume(data) {
  return requset({
    url: `${WRITE}/volume/edit`,
    method: "POST",
    data
  });
}
/* 删除分卷 */
export function delVolume(params) {
  return requset({
    url: `${WRITE}/volume/del`,
    method: "GET",
    params
  });
}
/* 提交新建章节 */
export function addChapter(data) {
  return requset({
    url: `${WRITE}/chapter/add`,
    method: "POST",
    data
  });
}

/* =====发布作品 */
export function publishBook(bookid) {
  return requset({
    url: `${WRITE}/book/open/${bookid}`,
    method: "get"
  });
}
/* ================草稿箱*/
//==获取章节目录
export function draftChapters(params) {
  return requset({
    url: `${WRITE}/chapter/draftChapters`,
    method: "get",
    params
  });
}
// ==获取章节内容
export function getEditCon(params) {
  return requset({
    url: `${WRITE}/chapter/edit`,
    method: "get",
    params
  });
}
// ==获取卷内容
export function getVoCon(params) {
  return requset({
    url: `${WRITE}/volume/info`,
    method: "get",
    params
  });
}
// 修改章节信息
export function editChapter(data) {
  return requset({
    url: `${WRITE}/chapter/edit`,
    method: "POST",
    data
  });
}

/* =====发布章节 */
// 发布新章节
export function publishChapter(data) {
  return requset({
    url: `${WRITE}/chapter/add`,
    method: "POST",
    data
  });
}
// 发布章节
export function publishOldChapter(data) {
  return requset({
    url: `${WRITE}/chapter/edit`,
    method: "POST",
    data
  });
}
// 获取已发布章节目录
export function getPublishVo(bookid) {
  return requset({
    url: `${WRITE}/chapter/list/${bookid}`,
    method: "get"
  });
}
// 获取最新已发布章节内容
export function getnewCon(params) {
  return requset({
    url: `${WRITE}/chapter/update/last`,
    method: "get",
    params
  });
}
// 删除章节
export function delChapter(params) {
  return requset({
    url: `${WRITE}/chapter/delete`,
    method: "get",
    params
  });
}

/* ================================作品签约 */
// 获取作家基本信息
export function getNormalInfo() {
  return requset({
    url: `${AUTHOR}/author/info`,
    method: "GET"
  });
}
// 修改基本信息
export function changeNormalInfo(data) {
  return requset({
    url: `${AUTHOR}/author/modify`,
    method: "POST",
    data
  });
}

/* 获取作品签约信息 */
export function getSignInfo(bookId) {
  return requset({
    url: `${AUTHOR}/book/invited/${bookId}`,
    method: "GET"
  });
}

// 身份证验证
export function checkidNo(params) {
  return requset({
    url: `${AUTHOR}/book/author/verify_page`,
    method: "POST",
    params
  });
}
/* 发送邮箱验证码 */
export function sendCode(data) {
  return requset({
    url: `${AUTHOR}/sendCode`,
    method: "POST",
    data
  });
}
// 签约
export function signBook(data, bookId) {
  return requset({
    url: `${AUTHOR}/book/apply/contract/${bookId}`,
    method: "POST",
    data
  });
}

// 绑定主账号
export function bindMainId(data) {
  return requset({
    url: `${AUTHOR}/accounts/bundle/author`,
    method: "POST",
    data
  });
}
/*子账号绑定申请审核  */
export function isbindpass(data) {
  return requset({
    url: `${AUTHOR}/accounts/bundle/inspect`,
    method: "POST",
    data
  });
}
/*取消绑定 */
export function canclebind() {
  return requset({
    url: `${AUTHOR}/accounts/bundle/cancle`,
    method: "POST"
  });
}
// 是否能变更账户
export function ischangeMainId() {
  return requset({
    url: `${AUTHOR}/accounts/author/modify`,
    method: "GET"
  });
}
// 变更账户
export function changeMainId(data) {
  return requset({
    url: `${AUTHOR}/accounts/author/modify`,
    method: "POST",
    data
  });
}
